import HtmlContent from '@/components/HtmlContent'
import NewLabel from '@/components/Labels/NewLabel'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import style from '../styles/games.module.scss'

interface IProps {
  title: string
  description: string
  newGame: boolean
  url: string
  video?: string
  preview: string
}

const BigCard = ({
  title = '',
  description = '',
  newGame = false,
  url = '/',
  video,
  preview
}: IProps): React.ReactElement => {
  const [playVideo, setPlayVideo] = useState(false)

  const hadnlePlayVideo = (): void => {
    setPlayVideo(true)
  }

  const handleStopVideo = (): void => {
    setPlayVideo(false)
  }

  return (
    <Link
      to={url}
      className={style.card}
      onMouseOver={hadnlePlayVideo}
      onMouseOut={handleStopVideo}
    >
      {playVideo && Boolean(video)
        ? (
          <video
            src={video}
            autoPlay
            muted
            loop
            controlsList='nodownload nofullscreen noremoteplayback'
            className={style.card__video}
          />
          )
        : (
          <img
            src={preview}
            width='450px'
            height='450px'
            alt={title}
            className={style.card__image}
          />
          )}
      <div className={style.card_content}>
        <h2 className={style.card__title}>{title}</h2>
        <HtmlContent content={description} className={style.card__desc} />
      </div>
      {newGame
        ? (
          <NewLabel side='left' className={style.card__new} />
          )
        : undefined}
    </Link>
  )
}

export default BigCard
